import React from "react";
import { useInView } from "react-intersection-observer";


const MobBoldQuote = ({content}) => {
    const { ref: upperLineRef, inView: upperLineInView } = useInView({
        triggerOnce: true,
        rootMargin: "0px 0px 0px 0px",
        threshold: 0,
    });

    const { ref: lowerLineRef, inView: lowerLineInView } = useInView({
        triggerOnce: true,
        rootMargin: "0px 0px 0px 0px",
        threshold: 0,
    });

    return(
        <>
            <div style={{
                fontFamily: "var(--font-bold)",
                fontWeight: "700",
                fontStretch: "condensed",
                fontSize: "23.5vw",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-end",
                marginTop: "10dvh",
                whiteSpace: "nowrap",
                lineHeight: 1
            }}>
                <span
                    style={{
                        overflow: "hidden"
                    }}
                >
                    <span
                        className={`${upperLineInView ? 'titleLineIn' : ''}`} 
                        style={{
                            display: "inline-block",
                            transform: "translate3d(0, 100%, 0)",
                            opacity: 0,
                            fontSize: content.lastQuote[0].length >10 ? "19vw" : null
                        }}
                        ref={upperLineRef}
                    >{content.lastQuote[0]}</span>
                </span>
                <span 
                    className="hollow-text"
                    style={{
                        overflow: "hidden",
                        lineHeight: 1.1,
                        display: "flex",
                    }}
                >
                    <span
                        ref={lowerLineRef}
                        className={`${upperLineInView ? 'titleLineIn' : ''}`} 
                        style={{
                            display: "inline-block",
                            transform: "translate3d(0, 100%, 0)",
                            opacity: 0,
                            fontSize: (content.lastQuote[1].length > 10 || content.lastQuote[0].length > 10) ? "19vw" : null
                        }}
                    >{content.lastQuote[1]}</span>
                </span>
            </div>
        </>
    )
}

export default MobBoldQuote;